import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { isSafeNumber } from '@ipfabric/frontend-shared-assets/utils/types/isSafeNumber';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useEffect } from 'react';

interface Props {
  name?: string;
  type: 'number' | 'search' | 'text' | 'password';
  value: unknown;
}

export const useCheckNumberInputBoundaries = (props: Props): void => {
  const validateNumberInput = useStableCallback((value: unknown) => {
    const number = value === 'string' ? Number(value) : value;

    if (typeof number !== 'number') {
      stumble(`The field ${props.name ?? ''} should be a number.`);
    } else if (!Number.isFinite(number)) {
      stumble(`The field ${props.name ?? ''} should be a finite number.`);
    } else if (!isSafeNumber(number)) {
      stumble(
        `The field ${props.name ?? ''} should contain the number greater than ${Number.MIN_SAFE_INTEGER} and lower than ${Number.MAX_SAFE_INTEGER}`,
      );
    }
  });

  useEffect(() => {
    props.type === 'number' &&
      props.value !== '' &&
      validateNumberInput(props.value);
  }, [props.type, props.value]);
};
